import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Badge as RmwcBadge} from '@rmwc/badge'
import '@rmwc/badge/styles'

const StyledRmwcBadge = styled(RmwcBadge)`
  &&& {
    margin: 0.5rem 0;
  }
  .mdc-theme--on-primary2 &&& {
    background: var(--mdc-theme-text-hint-on-primary2);
  }

  font-family: Roboto, sans-serif;
  font-size: 12px
  font-weight: 600;
`

const DrawerBadge = ({children, ...otherProps}) => (
  <StyledRmwcBadge align="inline" {...otherProps}>
    {children}
  </StyledRmwcBadge>
)

DrawerBadge.propTypes = {
  children: PropTypes.any
}

export {DrawerBadge}
